import * as React from 'react';
import { styled, alpha, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import CustomTooltip from './CustomTooltip';

const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
    },
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2,
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        border: "1px solid #d0d0d0",
        borderRadius: "50px",

        transition: theme.transitions.create('width'),
        backgroundColor: "#FFFFFF",
        '&::placeholder': {
            color: theme.palette.bgBlack.main,
        },
    },
}));

export default function CommonSearchField({ placeholder, categories, value, ...props }) {

    const theme = useTheme();

    const [searchTerm, setSearchTerm] = React.useState("");
    const [timer, setTimer] = React.useState(0);
    const WAIT_INTERVAL = 500;
    return (

        <CustomTooltip
            title={categories?.length > 0 ? <>
                <Typography variant="subtitle2">You can search by</Typography>
                <Box component="ul" sx={{ marginBlock: 0, marginInline: 0, paddingInline: 2, maxHeight: "200px", overflowY: "scroll" }}>
                    {categories?.map((val, i) => {
                        return <li key={i}>{val}</li>
                    })}
                </Box>
            </> : ""}>
            <Box display="flex" alignItems="center">
                <Search>
                    <SearchIconWrapper>
                        <SearchIcon style={{ color: theme.palette.primary.main }} />
                        {/* <IconWrapper icon='search' fontSize='20px' /> */}
                    </SearchIconWrapper>
                    <StyledInputBase
                        placeholder={placeholder ? placeholder : "Search"}
                        inputProps={{ 'aria-label': 'search' }}
                        value={value}
                        onChange={(ev) => {
                            setSearchTerm(ev.target.value);
                            let val = (ev.target.value || "").trim();
                            clearTimeout(timer);
                            setTimer(
                                setTimeout(() => {
                                    props.handleSearch && props.handleSearch(val);
                                }, WAIT_INTERVAL)
                            );
                        }}
                    />
                </Search>
            </Box>
        </CustomTooltip>
    );
}